import Manager from 'coreClasses/Manager';
import {receiveGiftCertificate, selectGiftCertificate} from 'coreStore/data/giftCertificates';
import type {GiftCertificate} from 'coreStore/data/giftCertificates/types';
import GiftCertificateModel from './GiftCertificateModel';

/**
 * Represents GiftCertificatesMgr
 */
class GiftCertificatesMgr extends Manager {
	/**
	 * Gets gift certificate model
	 * @param {String} giftCertificateCode gift certificate code
	 * @returns {GiftCertificateModel} - gift certificate model
	 */
	async getGiftCertificate(giftCertificateCode: string): Promise<GiftCertificateModel> {
		const store = this.managerRepository.getStoreMgr().getStore();
		await this.fetchGiftCertificate(giftCertificateCode);

		return new GiftCertificateModel(selectGiftCertificate(store.getState()));
	};

	/**
	 * Executes API call to get gift certificate
	 * @param {String} giftCertificateCode - gift certificate code
	 */
	private async fetchGiftCertificate(giftCertificateCode: string) {
		const giftCertificate = await this.managerRepository
			.getCommerceApi()
			.shopperGiftCertificates
			.getGiftCertificate({
				body: {
					giftCertificateCode: giftCertificateCode,
				}
			});

		if (giftCertificate.isError) {
			throw new Error(giftCertificate as any);
		}

		this.managerRepository.getStoreMgr().getStore().dispatch(receiveGiftCertificate(giftCertificate as unknown as GiftCertificate));
	};
}

export default GiftCertificatesMgr;
